import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'

import { setMainNavVisibility } from '../actions/mainNavVisibility'

import Footer from '../components/Footer/Footer'
import MainHeader from '../components/MainHeader/MainHeader'
import MainNav from '../components/MainNav/MainNav'
import NewsletterFooter from '../components/NewsletterFooter/NewsletterFooter'
import NewsletterModal from '../components/NewsletterModal/NewsletterModal'
import PageOverlay from '../components/PageOverlay/PageOverlay'
import TopMessage from '../components/TopMessage/TopMessage'

import '../styles/base.css'
import '../styles/webfonts.css'
import '../styles/styles.css'
import '../styles/swiper.css'

class MainLayout extends Component {
  componentDidUpdate(prevProps) {
    const { location, hideNav } = this.props
    if (prevProps.location.pathname !== location.pathname) {
      hideNav()
    }
  }

  render() {
    const { children, pageContext } = this.props
    const {
      translations = [
        { path: 'es/', nativeName: 'Español' },
        { path: '/', nativeName: 'English' },
      ],
      lang = 'en-gb',
      templateName,
    } = pageContext

    if (!translations || !lang) return null

    const hasHero = templateName === 'Homepage' || templateName === 'Longform'

    const getHreflang = nativeName => {
      switch (nativeName) {
        case 'Español':
          return 'es-ES'
        default:
          return 'x-default'
      }
    }

    return (
      <>
        <Helmet>
          {translations.map(({ nativeName, path }) => {
            const hreflang = getHreflang(nativeName)
            const href = `https://cabuyahandmade.com/${path}`
            return (
              <link
                key={nativeName}
                rel="alternate"
                hrefLang={hreflang}
                href={href}
              />
            )
          })}
        </Helmet>
        <div className="font-sans">
          <TopMessage />
          <MainHeader
            lang={lang}
            hasHero={hasHero}
            translations={translations}
          />
          <MainNav />
          {children}
          <NewsletterFooter />
          <NewsletterModal />
          <Footer translations={translations} layoutHasBottomAlert />
          <PageOverlay />
        </div>
      </>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideNav: () => dispatch(setMainNavVisibility(false)),
  }
}

export default connect(null, mapDispatchToProps)(MainLayout)
